module.exports = __webpack_public_path__ + "img/cc.1014990d.svg";